export const TAGS = {
  TemplateIds: "TemplateIds",
  Preprocessing_Rules: "Preprocessing_Rules",
  TemplateDetails: "TemplateDetials",
  Presigned_Url: "Presigned_Url",
  Translation_History: "Translation_History",
};
